/* eslint-disable no-restricted-syntax */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FaAngleRight, FaClock, FaPen, FaUserCircle } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { Badge, Modal, Nav, NavItem, NavLink } from 'reactstrap';
import api from '~/services/api';
import { Howl } from 'howler';
import Sound from '~/assets/sounds/phoneNotification-v1.mp3';
import { useAuth } from '~/context/AuthContext';
import formatTime from '~/services/formatTime';
import {
  Button as ButtonStyled,
  Checkbox,
  Dropdown,
  IconFilterList,
} from 'takeat-design-system-ui-kit';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import toast from 'react-hot-toast';
import OrdersCanceled from './OrdersCanceled';
import OrdersFinished from './OrdersFinished';
import OrdersNew from './OrdersNew';
import {
  Card,
  Container,
  Header,
  NavLinkSpan,
  HeaderTitle,
  CanceledCard,
  AlteredCard,
  CardHeader,
  Footer,
  ModalStyled,
  FilterArea,
  DropdownItem,
} from './styles';
import EditKitchen from './EditKitchen';

import OrderItem from './OrderCard/OrderItem';
import { BuyerInfo, ConfirmButton, Orders } from './OrderCard/styles';
import OrderItemsCanceled from './OrderCard/OrderItemsCanceled';

const priorities = {
  pending: 1,
  doing: 2,
  finished: 3,
  canceled: 4,
};

function Kitchen() {
  const { websocketManager, user, shouldFetchKds, setShouldFetchKds } =
    useAuth();
  const location = useLocation();
  const { item, kds_index } = location.state;
  const [isModalCancelOpened, setIsModalCancelOpened] = useState(false);
  const [isModalCancelBasketsOpened, setIsModalCancelBasketsOpened] =
    useState(false);
  const [isModalAlterOpened, setIsModalAlterOpened] = useState(false);

  const [itemCanceledState, setItemCanceledState] = useState({});
  const toggleIsModalCancelOpened = useCallback(
    (item) => {
      setIsModalCancelOpened(!isModalCancelOpened);
      setItemCanceledState(item);
    },
    [isModalCancelOpened]
  );

  const [itemsCanceledState, setItemsCanceledState] = useState([]);

  const toggleIsModalCancelBasketsOpened = useCallback(
    (item) => {
      setIsModalCancelBasketsOpened(!isModalCancelBasketsOpened);
      setItemsCanceledState(item);
    },
    [isModalCancelOpened]
  );

  const toggleIsModalAlterOpened = useCallback(
    (item) => {
      setIsModalAlterOpened(!isModalAlterOpened);
      setItemCanceledState(item);
    },
    [isModalAlterOpened]
  );

  const [kdsState, setKdsState] = useState(item);

  const getKds = useCallback(async () => {
    const response = await api.get(`/restaurants/kds/${item.id}`);

    const kdsFind = response.data;

    setKdsState(kdsFind);
  }, [item]);

  useEffect(() => {
    try {
      getKds();
    } catch (error) {
      console.log(error.message);
    }
  }, [getKds]);
  const [activeTab, setActiveTab] = useState('1');

  const [modalEditKitchen, setModalEditKitchen] = useState(false);

  function toggleModalEditKitchen() {
    setModalEditKitchen(!modalEditKitchen);
  }

  const [channelType, setChannelType] = useState([
    'balcony',
    'table',
    'drive-thru',
    'all',
    'delivery',
    'ifood',
    '99food',
    'neemo',
    'withdrawal',
  ]);

  function handleSetChannelType(type) {
    setChannelType((old) => {
      if (type === 'all') {
        if (!old.includes('all')) {
          return [
            'all',
            'delivery',
            'ifood',
            '99food',
            'drive-thru',
            'neemo',
            'withdrawal',
            ...(old.includes('table') ? ['table', 'balcony'] : []),
          ];
        }

        if (
          old.includes(
            'all',
            'delivery',
            'drive-thru',
            'ifood',
            '99food',
            'neemo',
            'withdrawal',
          )
        ) {
          return old.includes('table') ? ['table', 'balcony'] : [];
        }

        return old.filter((item) => item !== 'all');
      }

      if (type === 'table') {
        return old.includes('table')
          ? old.filter((item) => item !== 'table' && item !== 'balcony')
          : [...old, 'table', 'balcony'];
      }

      const newChannels = old.includes(type)
        ? old.filter((item) => item !== type)
        : [...old, type];

      const selectableChannels = [
        'delivery',
        'drive-thru',
        'ifood',
        '99food',
        'neemo',
        'withdrawal',
      ];
      const selectedChannels = newChannels.filter((item) =>
        selectableChannels.includes(item)
      );

      if (selectedChannels.length === selectableChannels.length) {
        return [...new Set([...newChannels, 'all'])];
      }

      return newChannels.filter((item) => item !== 'all');
    });
  }

  function handleVerifyChecked(type) {
    return type.some((item) => channelType.includes(item));
  }

  const verifyOrdernation = useCallback(
    (baskets_compare) => {
      if (!baskets_compare) return [];

      const filteredBaskets = baskets_compare.filter((basket) =>
        channelType.includes(basket.channel)
      );

      filteredBaskets.sort((a, b) => {
        // 1. Ordena por status (pending > doing > finished > canceled)
        if (a.status !== b.status) {
          return priorities[b.status] - priorities[a.status];
        }

        // 2. Dentro do mesmo status, TURBO vai pro topo
        const aIsTurbo = a.delivery_mode === 'TURBO';
        const bIsTurbo = b.delivery_mode === 'TURBO';

        if (aIsTurbo && !bIsTurbo) return -1;
        if (!aIsTurbo && bIsTurbo) return 1;

        // 3. Por último, ordena por arrived_at (mais antigo primeiro)
        return (
          new Date(a.arrived_at).valueOf() - new Date(b.arrived_at).valueOf()
        );
      });

      return filteredBaskets;
    },
    [channelType]
  );

  const verifyFinishedOrdernation = useCallback((baskets_compare) => {
    if (baskets_compare) {
      baskets_compare.sort(
        (a, b) => new Date(b.arrived_at) - new Date(a.arrived_at)
      );
    }
    return baskets_compare;
  }, []);

  function playSoundHowler() {
    const sound = new Howl({
      src: Sound,
      volume: 1,
      preload: true,
    });
    sound.play();
  }

  const [baskets, setBaskets] = useState([]);
  const prevBasketsRef = useRef([]);

  const getBaskets = useCallback(async () => {
    const response = await api.get(`/restaurants/kds/baskets/${item?.id}`);

    const responseFormatted = response.data.map((item) => {

      if (item.with_withdrawal && item.channel !== 'ifood') {
        return { ...item, channel: 'withdrawal' };
      }

      return item;
    });
    const basketOrdened = verifyOrdernation(responseFormatted);

    if (prevBasketsRef.current.length > 0) {
      if (prevBasketsRef.current.length < response.data.length) {
        if (kdsState.notify_sound) {
          playSoundHowler();
        }
      }
    }
    setBaskets(basketOrdened);
    prevBasketsRef.current = basketOrdened;
  }, [item, verifyOrdernation, kdsState.notify_sound]);

  useEffect(() => {
    if (websocketManager) {
      websocketManager.addMessageCallback(5, (data) => {
        if (data.type === 'kds:new-orders' || data.type === 'new-transfer') {
          getBaskets();
        } else if (data.type === 'kds:basket-status') {
          const kds_baskets = data.item.updated_baskets;

          const kds_ids = kds_baskets.map((d) => d.kds_id);

          if (kds_ids.includes(item.id)) {
            const kds_basket_ids = kds_baskets.map((d) => d.id);

            setBaskets((state) => {
              const newBaskets = [...state];

              let baskets_has_been_updated = false;

              for (const basket of newBaskets) {
                const updated_basket = kds_baskets.find(
                  (kb) => kb.id === basket.id
                );

                if (updated_basket) {
                  const { order_ids, unchecked_order_ids } = data.item;

                  // Atualizando os itens checados
                  if (updated_basket.status === 'finished') {
                    for (const ko of basket.kds_orders) {
                      ko.checked = true;
                    }
                  } else if (order_ids) {
                    for (const ko of basket.kds_orders) {
                      if (order_ids.includes(ko.order_id)) {
                        ko.checked = true;
                      }
                    }
                  } else if (unchecked_order_ids) {
                    for (const ko of basket.kds_orders) {
                      if (unchecked_order_ids.includes(ko.order_id)) {
                        ko.checked = false;
                      }
                    }
                  }

                  if (updated_basket.is_active !== undefined) {
                    basket.is_active = updated_basket.is_active;
                  } else if (updated_basket.status === 'doing' || updated_basket.status === 'pending') {
                    // Se voltou para doing/pending e is_active não veio, garante que seja true
                    basket.is_active = true;
                  }

                  if (updated_basket.arrived_at !== undefined) {
                    basket.arrived_at = updated_basket.arrived_at;
                  }

                  basket.status = updated_basket.status;
                  baskets_has_been_updated = true;
                }
              }

              if (baskets_has_been_updated) {
                return verifyOrdernation(newBaskets);
              }

              return state;
            });
          }
        } else if (data.type === 'kds:order-check') {
          const kdsData = data.item;

          const { order_id, checked } = data.item;
          const kds_baskets = data.item.updated_baskets;

          const kds_ids = kds_baskets.map((d) => d.kds_id);

          if (kds_ids.includes(item.id)) {
            setBaskets((state) => {
              const newBaskets = [...state];

              let baskets_has_been_updated = false;

              for (const basket of newBaskets) {
                const updated_basket = kds_baskets.find(
                  (kb) => kb.id === basket.id
                );

                if (updated_basket) {
                  // Se o status local já é 'finished', não sobrescreve (preserva optimistic update)
                  if (basket.status === 'finished') {
                    continue;
                  }

                  const order_idx = basket.kds_orders.findIndex(
                    (item) => item.order_id === order_id
                  );

                  if (order_idx > -1) {
                    basket.kds_orders[order_idx].checked = checked;
                  }

                  if (updated_basket.is_active !== undefined) {
                    basket.is_active = updated_basket.is_active;
                  } else if (updated_basket.status === 'doing' || updated_basket.status === 'pending') {
                    // Se voltou para doing/pending e is_active não veio, garante que seja true
                    basket.is_active = true;
                  }

                  if (updated_basket.arrived_at !== undefined) {
                    basket.arrived_at = updated_basket.arrived_at;
                  }

                  basket.status = updated_basket.status;

                  baskets_has_been_updated = true;
                }
              }

              if (baskets_has_been_updated) {
                return verifyOrdernation(newBaskets);
              }

              return state;
            });
          }
        } else if (data.type === 'kds:cancel-basket') {
          const kdsBaskets = data.item.kds_baskets;

          const kdsBasketFind = kdsBaskets.find(
            (basket) => basket.kds_id === item.id
          );

          const kdsBasketsFind = kdsBaskets.filter(
            (basket) => basket.kds_id === item.id
          );

          if (kdsBaskets.length > 1 && kdsBasketsFind) {
            toggleIsModalCancelBasketsOpened(kdsBasketsFind);
          } else if (kdsBasketFind) {
            toggleIsModalCancelOpened(kdsBasketFind);
          }
        } else if (data.type === 'kds:cancel-order-item') {
          const kdsBaskets = data.item.kds_baskets;

          const kdsBasketFind = kdsBaskets.find(
            (basket) => basket.kds_id === item.id
          );

          if (kdsBasketFind) {
            toggleIsModalCancelOpened(kdsBasketFind);
          }
        } else if (data.type === 'kds:cancel-order-amount') {
          const kdsBaskets = data.item.kds_baskets;

          const kdsBasketFind = kdsBaskets.find(
            (basket) => basket.kds_id === item.id
          );

          if (kdsBasketFind) {
            toggleIsModalCancelOpened(kdsBasketFind);
          }
        } else if (data.type === 'kds:basket-alter') {
          const kdsBaskets = data.item.kds_baskets;

          const kdsBasketFiltered = kdsBaskets.filter(
            (basket) => basket.kds_id === item.id
          );

          if (kdsBasketFiltered.length === 1) {
            toggleIsModalAlterOpened(kdsBasketFiltered[0]);
          } else if (kdsBasketFiltered.length > 1) {
            const first = kdsBasketFiltered[0];

            first.kds_orders = kdsBasketFiltered
              .map((b) => b.kds_orders)
              .flat();

            toggleIsModalAlterOpened(first);
          }
        }
      });

      return () => {
        websocketManager.addMessageCallback(5, (data) => { });
      };
    }
  }, [
    websocketManager,
    getBaskets,
    baskets,
    kdsState,
    item,
    toggleIsModalCancelOpened,
    toggleIsModalCancelBasketsOpened,
    verifyOrdernation,
  ]);

  useEffect(() => {
    if (shouldFetchKds) {
      setShouldFetchKds(false);
      getBaskets();
      toast.success('Kds atualizado com sucesso!');
    }
  }, [shouldFetchKds, getBaskets]);

  useEffect(() => {
    getBaskets();
  }, [getBaskets]);

  const history = useHistory();

  function handleGoBack() {
    history.goBack();
  }

  return (
    <Container>
      <Modal isOpen={isModalCancelOpened}>
        <CanceledCard>
          <CardHeader>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>#{itemCanceledState?.basket_key}</span>
              <span
                style={{ fontWeight: 'bold', fontSize: 16 }}
              >{`Mesa ${itemCanceledState?.table?.table_number}`}</span>
            </div>

            <Badge pill className="bg-danger">
              <span style={{ fontWeight: 'bold', color: '#fff', fontSize: 16 }}>
                Cancelado
              </span>
            </Badge>
          </CardHeader>
          <BuyerInfo isProductLate={false}>
            <span>
              <FaUserCircle />{' '}
              <span>
                {itemCanceledState?.buyer
                  ? itemCanceledState?.buyer?.name
                  : itemCanceledState?.waiter?.name}
              </span>
            </span>
            <span>
              <FaClock />{' '}
              <span>
                {itemCanceledState &&
                  itemCanceledState.createdAt &&
                  formatTime(itemCanceledState?.createdAt)}
              </span>
            </span>
          </BuyerInfo>
          <Orders>
            {itemCanceledState &&
              itemCanceledState?.kds_orders &&
              itemCanceledState?.kds_orders.length > 0 &&
              itemCanceledState?.kds_orders
                .filter((kds_order) => kds_order.canceled_at)
                .map((product, index) => (
                  <OrderItem
                    isLate={false}
                    product={product}
                    index={index}
                    key={product.id}
                  />
                ))}
          </Orders>

          <Footer>
            <ConfirmButton
              type="button"
              status="canceled"
              onClick={() => {
                setIsModalCancelOpened(false);
                getBaskets();
              }}
            >
              Confirmar
            </ConfirmButton>
          </Footer>
        </CanceledCard>
      </Modal>

      <Modal isOpen={isModalCancelBasketsOpened}>
        <CanceledCard>
          <CardHeader>
            <span
              style={{ fontWeight: 'bold', fontSize: 16 }}
            >{`Mesa ${itemsCanceledState[0]?.table?.table_number}`}</span>

            <Badge pill className="bg-danger">
              <span style={{ fontWeight: 'bold', color: '#fff', fontSize: 16 }}>
                PEDIDOS CANCELADOS
              </span>
            </Badge>
          </CardHeader>
          {/* <BuyerInfo>
            <span>
              <FaUserCircle />{' '}
              <span>
                {itemCanceledState?.buyer
                  ? itemCanceledState?.buyer?.name
                  : itemCanceledState?.waiter?.name}
              </span>
            </span>
            <span>
              <FaClock />{' '}
              <span>
                {itemCanceledState &&
                  itemCanceledState.createdAt &&
                  formatTime(itemCanceledState?.createdAt)}
              </span>
            </span>
          </BuyerInfo> */}
          {/* <Orders>
            {itemCanceledState &&
              itemCanceledState?.kds_orders &&
              itemCanceledState?.kds_orders.length > 0 &&
              itemCanceledState?.kds_orders
                .filter((kds_order) => kds_order.canceled_at)
                .map((product, index) => (
                  <OrderItem
                    isLate={false}
                    product={product}
                    index={index}
                    key={product.id}
                  />
                ))}
          </Orders> */}
          {itemsCanceledState.map((item, index) =>
            item.kds_orders
              .filter((order) => order.canceled_at)
              .map((product, idx) => (
                <OrderItemsCanceled
                  key={product.id}
                  isLate={false}
                  product={product}
                  index={idx}
                  basket={item}
                />
              ))
          )}

          <Footer>
            <ConfirmButton
              type="button"
              status="canceled"
              onClick={() => {
                setIsModalCancelBasketsOpened(false);
                getBaskets();
              }}
            >
              Confirmar
            </ConfirmButton>
          </Footer>
        </CanceledCard>
      </Modal>

      <Modal isOpen={isModalAlterOpened}>
        <AlteredCard>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: 10,
            }}
          >
            <span
              style={{ fontWeight: 'bold', color: '#ffffff', fontSize: 16 }}
            >
              Delivery
            </span>

            <Badge pill className="bg-light">
              <span
                style={{ fontWeight: 'bold', color: '#ccbbed', fontSize: 16 }}
              >
                Pedido Alterado
              </span>
            </Badge>
            <span style={{ color: '#fff' }}>
              #{itemCanceledState?.attendance_password}
            </span>
          </div>
          <BuyerInfo isProductLate={false}>
            <span>
              <FaUserCircle />{' '}
              <span>
                {itemCanceledState?.buyer
                  ? itemCanceledState?.buyer?.name
                  : itemCanceledState?.waiter?.name}
              </span>
            </span>
            <span>
              <FaClock />{' '}
              <span>
                {itemCanceledState &&
                  itemCanceledState.createdAt &&
                  formatTime(itemCanceledState?.createdAt)}
              </span>
            </span>
          </BuyerInfo>
          <Orders>
            {itemCanceledState &&
              itemCanceledState?.kds_orders &&
              itemCanceledState?.kds_orders.length > 0 &&
              itemCanceledState?.kds_orders.map((product, index) => (
                <OrderItem
                  isLate={false}
                  product={product}
                  index={index}
                  key={product.id}
                />
              ))}
          </Orders>

          <ConfirmButton
            type="button"
            status="alter"
            onClick={() => {
              setIsModalAlterOpened(false);
              getBaskets();
            }}
          >
            Confirmar
          </ConfirmButton>
        </AlteredCard>
      </Modal>

      <ModalStyled toggle={toggleModalEditKitchen} isOpen={modalEditKitchen}>
        <EditKitchen
          toggleModalEditKitchen={toggleModalEditKitchen}
          kdsState={kdsState}
        />
      </ModalStyled>
      <Header>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <HeaderTitle>
            <span>
              KDS <FaAngleRight /> {kdsState?.name}
            </span>
          </HeaderTitle>
          <Badge
            pill
            className="bg-secondary"
            style={{ cursor: 'pointer', marginLeft: 8, marginBottom: 0 }}
            onClick={toggleModalEditKitchen}
          >
            <FaPen color="#fff" />
            <span style={{ color: '#fff', marginLeft: 4 }}>Editar</span>
          </Badge>
        </div>

        <ButtonStyled onClick={handleGoBack}>Voltar</ButtonStyled>
      </Header>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          marginTop: 10,
        }}
      >
        <Nav
          tabs
          style={{
            padding: 0,
          }}
        >
          <NavItem>
            <NavLink
              className={activeTab === '1' ? 'active' : ''}
              onClick={() => setActiveTab('1')}
              style={{ cursor: 'pointer', color: '#333', marginBottom: 6 }}
            >
              <NavLinkSpan>Pedidos</NavLinkSpan>{' '}
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={activeTab === '2' ? 'active' : ''}
              onClick={() => {
                setActiveTab('2');
              }}
              style={{ cursor: 'pointer', color: '#333', marginBottom: 6 }}
            >
              <NavLinkSpan style={{ display: 'flex' }}>
                Pedidos finalizados
                <span className="badge bg-secondary" style={{ marginLeft: 8 }}>
                  {baskets.filter((item) => item.status === 'finished').length}
                </span>
              </NavLinkSpan>{' '}
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={activeTab === '3' ? 'active' : ''}
              onClick={() => {
                setActiveTab('3');
              }}
              style={{ cursor: 'pointer', color: '#333', marginBottom: 6 }}
            >
              <NavLinkSpan style={{ display: 'flex' }}>
                Pedidos cancelados
                <span className="badge bg-secondary" style={{ marginLeft: 8 }}>
                  {baskets.filter((item) => item.status === 'canceled').length}
                </span>
              </NavLinkSpan>{' '}
            </NavLink>
          </NavItem>
        </Nav>

        <FilterArea>
          <span
            style={{
              fontSize: 12,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <IconFilterList /> Filtro:
          </span>
          <ButtonStyled
            onClick={() => handleSetChannelType('table')}
            style={{
              backgroundColor: handleVerifyChecked(['table', 'balcony'])
                ? '#C8131B'
                : '#EDEDED',
              color: handleVerifyChecked(['table', 'balcony'])
                ? '#fff'
                : '#000',
              height: 32,
            }}
          >
            Presencial
          </ButtonStyled>

          <div>
            <ButtonStyled
              id="dropdown-button"
              style={{
                backgroundColor: handleVerifyChecked([
                  'all',
                  'delivery',
                  'ifood',
                  '99food',
                  'neemo',
                  'withdrawal',
                ])
                  ? '#C8131B'
                  : '#EDEDED',
                color: handleVerifyChecked([
                  'all',
                  'delivery',
                  'ifood',
                  '99food',
                  'neemo',
                  'withdrawal',
                ])
                  ? '#fff'
                  : '#000',
                height: 32,
              }}
            >
              Delivery
            </ButtonStyled>
            <Dropdown anchor="dropdown-button" style={{ width: 196 }}>
              <DropdownItem>
                <Checkbox
                  onClick={() => handleSetChannelType('all')}
                  checked={handleVerifyChecked(['all'])}
                />{' '}
                Todos
              </DropdownItem>
              <DropdownItem>
                <Checkbox
                  onClick={() => handleSetChannelType('delivery')}
                  checked={handleVerifyChecked(['delivery', 'all'])}
                />{' '}
                Delivery
              </DropdownItem>

              {user?.has_drive_thru && (
                <DropdownItem>
                  <Checkbox
                    onClick={() => handleSetChannelType('drive-thru')}
                    checked={handleVerifyChecked(['drive-thru', 'all'])}
                  />{' '}
                  Drive-Thru
                </DropdownItem>
              )}

              {user?.has_ifood && (
                <DropdownItem>
                  <Checkbox
                    onClick={() => handleSetChannelType('ifood')}
                    checked={handleVerifyChecked(['ifood', 'all'])}
                  />{' '}
                  Ifood
                </DropdownItem>
              )}

              {user?.has_99food && (
                <DropdownItem>
                  <Checkbox
                    onClick={() => handleSetChannelType('99food')}
                    checked={handleVerifyChecked(['99food', 'all'])}
                  />{' '}
                  99Food
                </DropdownItem>
              )}

              {user?.neemo_token && (
                <DropdownItem>
                  <Checkbox
                    onClick={() => handleSetChannelType('neemo')}
                    checked={handleVerifyChecked(['neemo', 'all'])}
                  />{' '}
                  Neemo
                </DropdownItem>
              )}

              <DropdownItem>
                <Checkbox
                  onClick={() => handleSetChannelType('withdrawal')}
                  checked={handleVerifyChecked(['withdrawal', 'all'])}
                />{' '}
                Retirada
              </DropdownItem>
            </Dropdown>
          </div>
        </FilterArea>
      </div>

      <Card>
        {activeTab === '1' && (
          <OrdersNew
            baskets={verifyOrdernation(baskets)}
            setBaskets={setBaskets}
            kdsViewMode={kdsState?.view_mode}
            kds={item}
            kds_index={kds_index}
          />
        )}
        {activeTab === '2' && (
          <OrdersFinished
            baskets={verifyFinishedOrdernation(baskets)}
            kdsViewMode={kdsState?.view_mode}
            kds={item}
            kds_index={kds_index}
          />
        )}
        {activeTab === '3' && (
          <OrdersCanceled
            baskets={baskets}
            kdsViewMode={kdsState?.view_mode}
            kds={item}
            kds_index={kds_index}
          />
        )}
      </Card>
    </Container>
  );
}

export default Kitchen;
